const digest = '4aaa500209183d02768fbd440dfaf06ad4c496e83332396d9d4c02bea4b2d154';
const css = `._inputWrapper_18t7v_1:focus-within input{max-width:calc(100% - 2.75rem)}._inputField_18t7v_5>div{margin-top:0}._clearButtonVariantA_18t7v_20,._clearButton_18t7v_9{border:0!important;bottom:3px;height:2.75rem!important;min-height:2.75rem!important;min-width:2.75rem!important;padding:0;right:3px;width:2.75rem!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'inputWrapper': '_inputWrapper_18t7v_1', 'inputField': '_inputField_18t7v_5', 'clearButton': '_clearButton_18t7v_9', 'clearButtonVariantA': '_clearButtonVariantA_18t7v_20' };
export const inputWrapper = '_inputWrapper_18t7v_1';
export const inputField = '_inputField_18t7v_5';
export const clearButton = '_clearButton_18t7v_9';
export const clearButtonVariantA = '_clearButtonVariantA_18t7v_20';
export { css, digest };